// extracted by mini-css-extract-plugin
module.exports = {"header_bg":"jobHeader_header_bg__2jBDt","grey_text":"jobHeader_grey_text__2qYwO"};